import { CheckInStatusEnum } from '../enums/check-in-status-type.enum';
import { AgencyStoreDto } from './agency-store.model';
import { LocationFullDTO } from './location.model';


export class AgencyDto {
  id: number;
  name: string;
  fiscalCode: string;
  checkInStatus: CheckInStatusEnum;
  vatNumber: string;
  // code: string;
  externalId: string;
  locationId: number;
  location?: LocationFullDTO;
  companyFormId: number;
  lastModificationTime?: string;
  creationTime?: string;
  creatorId?: number;
  lastModifierId?: number;
  fullName?: string;
  checkInMessage?: string;
  storeActivations: AgencyStoreDto[];
  constructor(init?: Partial<AgencyDto>) {
    Object.assign(this, init);
  }
}
